import { Component, OnInit, Input } from '@angular/core';
import { GetService } from '../../dataservice/get.service';
import { environment } from '../../../environments/environment';
import { LanguageService } from '../../dataservice/language.service';

@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.css']
})
export class EventComponent implements OnInit {

  finished: boolean = false;
  // referal_id='R596c86077e025';
  // product_type_id=134;
  // product_type=7;
  event_detail: any;
  event_highlight: any;
  @Input() referal_id;
  @Input() product_type;
  @Input() product_type_id;
  is_res_received = false;
  no_recfound = false;

  @Input() eventType: string;

  constructor(public mls: LanguageService, public getApiService: GetService) {
  }

  ngOnInit() {
    this.contentdetailShare();
  }

  contentdetailShare() {
    // setTimeout(() => {
    if (this.getApiService.is_login == '1') {
      this.getApiService.navigateToSection(7, this.product_type_id, this.eventType);
    }
    // }, 500);

    this.finished = false;
    this.getApiService.getContentShare(this.product_type, this.product_type_id, this.referal_id).subscribe(data => {

      this.finished = true;
      if (data.status == 1) {
        this.is_res_received = true;
        if (data.data.mix_list.length == 0) {
          this.no_recfound = true;
        }
        else if (this.event_detail = data.data.mix_list[0].products == null) {
          this.no_recfound = true;
        }
        this.event_detail = data.data.mix_list[0].products[0];

      } // condition closed
      else if (data.status == 0) {
        //    this.fcs.errorHandeler(data);
      }
    })
  }

  /**
   * Navigate user to event detail.
   */
  navigateto(): void {
      this.getApiService.navigateToSection(7, this.product_type_id, this.eventType);
  }

}
